var React = require('react');
var { connect } = require('react-redux');
var { timeSinceNowString } = require('helpers');
var dayjs = require('../../utils/dayjsConfig');
var IrrigationMeter = require('IrrigationMeter');
var { withTranslation, useTranslation } = require('react-i18next');
var { unitDisplayName } = require('unitsManager');
var fieldManager = require('fieldManager');
const { useState, useEffect } = require('react');

const IrrigationMeterDetailsContainer = (props) => {
  const [gauge, setGauge] = useState(null);
  const [stressLevel, setStressLevel] = useState(0);
  const [recommendation_date, setRecommendationDate] = useState('');
  const { t } = useTranslation();

  useEffect(() => {
    if (props.selectedField) {
      updateGauge(props.selectedField);
    }
  }, [props.loadHistoryStatus.status, props.selectedField, stressLevel]);

  // The gauge only needs the stress level and the recommendation timestamp —
  // crop water availability is rendered from the stress level alone, so no
  // irrigation amount / volume conversion is computed here.
  const updateGauge = (field) => {
    let stress_level = -1;
    let recommendation_date = dayjs();

    if (field) {
      let fieldItems = fieldManager.getFieldItems(field);
      stress_level = fieldItems.stressDataItem.value;
      recommendation_date = fieldItems.irrigationDataItem.date;
    }

    gauge?.updateMeterValue(stress_level);

    setStressLevel(stress_level);
    setRecommendationDate(timeSinceNowString(dayjs.unix(recommendation_date)));
  };

  let recommendationElement = <div></div>;
  let statusText = t('no_recommendation');
  let statusColorClass = 'text-grey71';

  if (props.selectedField) {
    // Get stressMsg like in FieldsSelector.jsx. Crop water availability is
    // shown for every planner state, so the v2 stress levels are always used.
    const fieldItems = fieldManager.getFieldItems(props.selectedField);
    const stressMsg = fieldManager.get_stress_message(
      fieldItems.stressDataItem.value,
      fieldItems.irrigationDataItem.value,
      fieldItems.accumulatedETc.value,
      null,
      unitDisplayName(props.userData['length']),
      true,
    );
    let stressMainMsg = undefined;
    let textColor = 'text-blue-secondary';
    // `get_stress_message` returns '' when the stress level falls outside every
    // band, so an absent mainMessage is the no-data case too.
    if (
      !stressMsg.mainMessage ||
      ['gauge_no_data_v2', 'no_recommendation_available'].includes(
        stressMsg.mainMessage,
      )
    ) {
      stressMainMsg = t('gauge_no_data_v2');
      textColor = 'text-grey71';
    } else {
      stressMainMsg = t(stressMsg.mainMessage);
    }
    statusText = stressMainMsg;
    statusColorClass = textColor;

    recommendationElement = (
      <div className='align-self-center'>
        <div className='text-center'>
          <div
            style={{
              width: 72,
              height: 32,
              textAlign: 'center',
              paddingTop: '2px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto',
            }}
            className={`font-weight-bold font-weight-bold text-size-14 align-items-center justify-content-center flex-row d-flex w-100 ${textColor}`}
          >
            {stressMainMsg}
          </div>
        </div>
      </div>
    );
  } else {
    recommendationElement = (
      <div
        className='text-size-14 text-center text-grey71 font-weight-bold'
        style={{
          lineHeight: '17px',
          whiteSpace: 'nowrap',
        }}
      >
        {t('no_recommendation')}
      </div>
    );
  }

  // Farm View "Field details" strip: label + status + synced time on the
  // left, gauge on the right (Figma "gauge cell", 255px).
  if (props.variant === 'farm') {
    const showSynced = recommendation_date && stressLevel !== -1;
    return (
      <div className='gauge-cell-farm'>
        <div className='gauge-cell-farm__text'>
          <span className='gauge-cell-farm__label' title={t('gauge_title_v3')}>
            {t('gauge_title_v3')}
          </span>
          <div className='gauge-cell-farm__wrap'>
            <span
              className={`gauge-cell-farm__status ${statusColorClass}`}
              data-testid='crop-water-availability-status'
            >
              {statusText}
            </span>
            {showSynced && (
              <span className='gauge-cell-farm__synced'>
                <img src={require('images/icons/timer_icon.svg')} alt='' />
                {t(recommendation_date[1]).format(recommendation_date[0])}
              </span>
            )}
          </div>
        </div>
        <div className='gauge-cell-farm__gauge'>
          <IrrigationMeter
            onRef={(ref) => setGauge(ref)}
            shouldDisplayInFieldDetails={true}
          />
        </div>
      </div>
    );
  }

  return (
    <div
      className='d-flex justify-content-center align-items-center bg-white gaugeContainer'
      style={{
        borderRadius: '15px',
        width: '330px',
        minHeight: '52px',
        gap: '4px',
        padding: '8px 24px 8px 24px',
      }}
    >
      <div
        className='d-flex flex-column justify-content-center gaugeTitlesContainer flex-grow-1'
        style={{ minWidth: '160px', maxWidth: '180px', gap: '4px' }}
      >
        <div
          className='text-grey45 text-size-14'
          style={{ minHeight: '18px', lineHeight: '17px', width: '100%' }}
        >
          {t('gauge_title_v3')}
        </div>
        {recommendation_date && stressLevel !== -1 && (
          <div
            className='text-grey71 text-size-12 text-truncate lastUpdatedGaugeText'
            style={{ height: '15px', lineHeight: '90%', width: '100%' }}
          >
            {t('updated') +
              ' ' +
              t(recommendation_date[1]).format(recommendation_date[0])}
          </div>
        )}
      </div>
      <div
        className='d-flex align-items-center flex-column'
        style={{ width: 'auto', height: 'auto', gap: '0px' }}
      >
        <div
          className='d-flex flex-column align-items-center justify-content-center flex-shrink-0'
          style={{ height: '40px' }}
        >
          <IrrigationMeter
            onRef={(ref) => setGauge(ref)}
            shouldDisplayInFieldDetails={true}
          />
        </div>
        <div
          className='d-flex align-items-center justify-content-center text-center flex-grow-1'
          style={{ height: '20px', minWidth: 72, gap: '4px' }}
        >
          {recommendationElement}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = function (state) {
  return {
    selectedField: state.distribution_data.selected_entities.field,
    userData: state.authentication_data.user_data,
    loadHistoryStatus: state.distribution_data.field_load_history,
  };
};

const mapDispatchToProps = {};

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(IrrigationMeterDetailsContainer));
